// extracted by mini-css-extract-plugin
module.exports = {"inputDateLabel":"InputDateLabel_inputDateLabel__3fQ1R"};